import Icon from "./Icon"

const Modes = () => {


  const printAnimations = () => {
    const transitionDefs = 'animation-duration: 3s;animation-direction: alternate;animation-iteration-count:infinite'
    return <style>
    {`
      @keyframes ani1_scroll {
        0% {transform: translateY(-200px);}
        100% {transform: translateY(0);}
      }
      @keyframes ani1_box {
        0% {transform: translateY(200px);}
        100% {transform: translateY(-200px);}
      }

    

      @keyframes ani1_outerBox2 {
        0% {transform: translateY(0px);}
        100% {transform: translateY(-240px);}
      }
      
      .scene1 .box{animation-name: ani1_box;${transitionDefs}}
      .scene1 .scroller{animation-name: ani1_scroll;${transitionDefs}}
      .outerBox2{animation-name: ani1_outerBox2;${transitionDefs}}

      @keyframes ani2_scroll {
        0% {transform: translateY(-200px);}
        100% {transform: translateY(0);}
      }
      @keyframes ani2_navi {
        0% {opacity:0;}
        20% {opacity:0;}
        30% {opacity:1;}
        100% {opacity:1;}
      }
      .scene2 .box{animation-name: ani1_box;${transitionDefs}}
      .scene2 .navi{animation-name: ani2_navi;${transitionDefs}}
      .scene2 .scroller{animation-name: ani2_scroll;${transitionDefs}}

      @keyframes floater{
        0% {
          box-shadow: 0 5px 15px 0px #cbd5e1;
          transform: translatey(0px);
        }
      
        50% {
          box-shadow: 0 25px 15px 0px #cbd5e1;
          transform: translatey(-20px);
        }
      
        100% {
          box-shadow: 0 5px 15px 0px #cbd5e1;
          transform: translatey(0px);
        }
      }

      .scene3 .flo{animation-name: floater;${transitionDefs}}
     


    `}
  </style>
  }


  const card_parallax =  <div className='flex-1 max-w-[500px] mx-auto'>
    <div className='bg-slate-100 h-[300px] rounded-2xl flex flex-col'>
      <div className='bg-slate-300 rounded-t-2xl h-8 gap-1 flex items-center px-4'>
        <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
        <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
        <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
      </div>
      <div className='flex-1 rounded-b-2xl flex items-center justify-center relative scene1 overflow-hidden'>
      
        <div className='bg-white shadow-xl shadow-slate-300 w-56 h-40 rounded-2xl box z-30'></div>
       
        <div className='absolute top-0 z-10 w-2/3 h-[200%] flex flex-col gap-4 outerBox2'>
          <div className='bg-slate-200 flex-1 rounded-2xl'></div>
          <div className='bg-slate-200 flex-1 rounded-2xl'></div>
          <div className='bg-slate-200 flex-1 rounded-2xl'></div>
        </div>
        <div className='scroller absolute bg-slate-200 h-10 w-2 rounded-xl bottom-2 right-2'></div>
      </div>
    </div>
    <div className='py-5 lg:p-5'>
      <h3>Parallax</h3>
      <p>Tween animations based on <span className='text-purple-500'>element percent position in viewport</span>. Typical use case is applying images a vertical position offset on scroll to achieve parallax effect.</p>
    </div>
  </div>

const card_scroll =  <div className='flex-1 max-w-[500px] mx-auto'>
<div className='bg-slate-100 h-[300px] rounded-2xl flex flex-col'>
  <div className='bg-slate-300 rounded-t-2xl h-8 gap-1 flex items-center px-4'>
    <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
    <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
    <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
  </div>
  <div className='flex-1 rounded-b-2xl flex items-center justify-center relative scene2 overflow-hidden'>
    <div className='absolute top-0 left-0 w-full z-40'>
      <div className='navi bg-white shadow-xl shadow-slate-300 inset-0 absolute z-20'></div>
      <div className='mx-10 flex justify-between items-center p-2 z-30 relative'>
        <div className='w-12 h-4 bg-slate-400 rounded-3xl'></div>
        <div className='w-4 h-4 bg-slate-400 rounded-3xl'></div>
      </div>
    </div>
    <div className='absolute top-0 z-10 w-2/3 h-[200%] flex flex-col gap-4 outerBox2'>
          <div className='bg-slate-200 flex-1 rounded-2xl'></div>
          <div className='bg-slate-200 flex-1 rounded-2xl'></div>
          <div className='bg-slate-200 flex-1 rounded-2xl'></div>
        </div>
    <div className='scroller absolute bg-slate-200 h-10 w-2 rounded-xl bottom-2 right-2'></div>
  </div>
</div>
<div className='py-5 lg:p-5'>
  <h3>Scroll</h3>
  <p>Trigger specific css styles and transformations after a <span className='text-purple-500'>fixed amout of scrolled pixels</span>. Typical use case is applying state specific styles to a header upon scroll.</p>
</div>
</div>

const card_timed =  <div className='flex-1 max-w-[500px] mx-auto'>
<div className='bg-slate-100 h-[300px] rounded-2xl flex flex-col'>
  <div className='bg-slate-300 rounded-t-2xl h-8 gap-1 flex items-center px-4'>
    <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
    <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
    <div className='bg-slate-400 w-2 h-2 rounded-full'></div>
  </div>
  <div className='flex-1 rounded-b-2xl flex items-center justify-center relative scene3 overflow-hidden'>
    <div className='absolute inset-12 bg-slate-200 rounded-2xl z-20'></div>
    <div className='bg-white w-40 h-40 flo rounded-2xl z-30'></div>
    <div className='absolute bottom-4 right-4 w-4 h-4 '>
      <div className='absolute top-0 left-1/2 w-[2px] h-1/2 bg-slate-300 rounded -ml-[1px]'></div>
    </div>
    <div className='absolute bottom-4 right-4 w-4 h-4 rotate-90'>
      <div className='absolute top-0 left-1/2 w-[2px] h-1/2 bg-slate-300 rounded -ml-[1px]'></div>
      <div className='w-[160%] h-[160%] -top-[30%] -left-[30%] border-2 border-slate-300 rounded-full absolute'></div>
    </div>
  </div>
</div>
<div className='py-5 lg:p-5'>
  <h3>Timed</h3>
  <p>Create <span className='text-purple-500'>time based</span> animations. Set duration, easing and animation repeat options to spice up element appearence. Typical use case is adding a float animation to an element to make it pop.</p>
</div>
</div>


    return <section className='p-10 lg:py-40'>
        {printAnimations()}
        <div className='text-center max-w-prose mx-auto'>
          <Icon name='cursor' outer='bg-violet-50' inner='fill-violet-500' />
          <h2>Point, Click and Animate</h2>
          <p className='sub'>Animator comes with 3 different animation modes to easily animate any element on your WordPress site.</p>
        </div>
        <div className='flex text-center lg:text-left flex-col lg:flex-row mt-10 lg:mt-20 lg:gap-10 items-stretch container mx-auto'>
         {card_parallax}
         {card_scroll}
         {card_timed}
         
        </div>
    </section>


}

export default Modes;